import React from 'react';

import { Table } from '@qality/common-components/src/atoms/Table';
import { ReportRowRawData } from '@qality/common-model';
import { EventUtils } from '@qality/common-utils';

type Props = {
  row: {
    key: string;
    cells: Array<any>;
  };
  extendProps: { pointer: boolean };
  handleClickRow?: () => void;
  rowRawData: ReportRowRawData;
  relativeLinkIndex: number;
};

const ReportTableRow = ({
  row,
  extendProps,
  handleClickRow,
  rowRawData,
  relativeLinkIndex,
}: Props): JSX.Element => {
  return (
    <Table.Tr
      key={row.key}
      isHoverable
      {...extendProps}
      onClick={
        handleClickRow &&
        handleClickRow.bind(this, rowRawData[relativeLinkIndex])
      }
    >
      {row.cells.map((cell, cellidx) => {
        const isActionColumn = relativeLinkIndex === cellidx;
        return (
          <Table.Td
            key={cellidx}
            {...(isActionColumn
              ? {
                  className: 'show-on-row-hover',
                }
              : null)}
            borderTop={!(cell.content.props.cell?.summary === '')}
          >
            <Table.ContentHelper
              {...(isActionColumn
                ? {
                    onClick: EventUtils.stopPropagation,
                  }
                : null)}
              alignItems='center'
            >
              {cell.content}
            </Table.ContentHelper>
          </Table.Td>
        );
      })}
    </Table.Tr>
  );
};

export default ReportTableRow;
